<template>
  <div class="index">
    <!--头部-->
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <jm-crumbs/>
          <el-form
            :model="searchData">
            <el-row>
              <el-col :span="6">
                <el-form-item
                  label-width="100px"
                  label="角色：">
                  <el-select
                    v-model="searchData.role_id"
                    filterable
                    class="jm-input135"
                    clearable
                    placeholder="请选择">
                    <el-option
                      v-for="(item, k) in ds.roleids"
                      :key="k"
                      :label="item.name"
                      :value="item.roleid"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label-width="100px"
                  label="咨询老师：">
                  <el-select
                    v-model="searchData.crm_sayer"
                    filterable
                    class="jm-input135"
                    clearable
                    placeholder="请选择">
                    <el-option-group
                      v-for="(group, k) in ds.advisory_teacher"
                      :key="k"
                      :label="k">
                      <el-option
                        v-for="item in group"
                        v-if="!searchData.role_id || searchData.role_id === item.roleid"
                        :key="item.userid"
                        :label="item.truename"
                        :value="item.userid"/>
                    </el-option-group>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label-width="110px"
                  label="最后回访：">
                  <el-date-picker
                    :editable="false"
                    v-model="searchData.lastVisitDate"
                    type="daterange"
                    unlink-panels
                    placeholder="选择日期"
                    class="jm-input280"/>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label-width="110px"
                  label="客户分级：">
                  <jm-dict-select
                    class="jm-input135"
                    clearable
                    type="dataset"
                    v-model="searchData.customerClassification"
                    dict-type="student"
                    name="customLvType"
                    :filter="(item) => $hasPermission([1, 80, 30, 77, 62, 89]) || item.value !== 66"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-button
                  class="jm-input135"
                  type="primary"
                  @click="() => this.refresh = true">搜索</el-button>
              </el-col>
            </el-row>
          </el-form>
          <jm-tableList
            url="/index/visit/getVisitReport"
            :search-data="searchData"
            :page-size="2000"
            :no-pagination="true"
            :refresh.sync="refresh">
            <el-table-column
              slot="crm_sayer"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              property="crm_sayer">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.crm_sayer }}
                </span>
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>
    <!--页脚-->
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';
import { jmDictSelect, } from '@/components/tool/index.js';
import ElRow from 'element-ui/packages/row/src/row';
import { jmChannel } from '@/components/tool';
import student from './student';

export default {
  data() {
    return {
      searchData: {
        lastVisitDate: '',
        crm_sayer: '', // 咨询老师
        customerClassification: '',
      },
      refresh: false,
      ds: {},
      exporting: false,
    };
  },
  components: {
    ElRow,
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    'jm-tableList': tableList,
    jmDictSelect,
    jmChannel,
  },
  computed: {
  },
  mixins: [student],
  methods: {
    getDatasource() {
      this.$http._get({
        url: '/index/Visit/searchDs',
      }).then((response) => {
        this.ds = response.data;
        // 咨询
        this.ds.advisory_teacher = this.formatTeacher(this.ds.advisory_teacher);
      });
    },
  },
  mounted() {
    this.getDatasource();
  },
};
</script>
<style scoped>
  .basic-padding {
    padding: 20px 10px;
    text-align: left;
  }
</style>
